export const endpoints = {
	public: "https://6fu1uerrj9.execute-api.us-east-1.amazonaws.com/v1",
	admin: "https://lsw92aem3e.execute-api.us-east-1.amazonaws.com/v1",
}

export const shipmentFields = {
	"step1":[
      {name:"shipmentDateRangeStart",label:"Delivery Date (from)",size:6, type:"datetime"},
      {name:"shipmentDateRangeEnd",label:"Delivery Date (to)",size:6, type:"datetime"},
      {name:"shipmentCarrier",label:"Carrier",size:8},
      {name:"shipmentSize",label:"Size",size:4},
      {name:"shipmentTrackingCode",label:"Tracking Code",size:9},
	]
};

export const locationFields = {
	"step1":[
      {name:"nickname",label:"Nickname",size:9},
	],
	"step2":[
      {name:"addressStreet1",label:"Street 1",size:12},
      {name:"addressStreet2",label:"Street 2",size:12},
      {name:"addressCity",label:"City",size:6},
      {name:"addressProvince",label:"Province",size:2},
      {name:"addressPostalCode",label:"Postal Code",size:4},
      {name:"addressCountry",label:"Country",size:12},
      {name:"contactMobile",label:"Mobile",size:12},
      {name:"contactEmail",label:"Email",size:12},
    ],
    "step3":[
      {name:"available",label:"Available",size:3, type:"toggle"},
  	],
};

export const stripe = {
  "publicKey": "pk_test_QK8zXYnrTSOS3WTknJS5awL0",
};



// WEBPACK FOOTER //
// ./src/variables/variables.jsx